import React, { useState } from "react";
import "../CSS/OrganizationRegistration.css";

const OrganizationRegistration = () => {
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    organization: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    }

    if (!formData.organization.trim()) {
      newErrors.organization = "Organization name is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      /*
        Connect this to your backend here.

        Example:

        const response = await fetch(
          "https://your-api.com/api/organizations/register",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const result = await response.json();
      */

      console.log("Organization:", formData);

      await new Promise((resolve) => setTimeout(resolve, 1200));

      alert("Organization profile created successfully!");

    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="organization-page">

      {/* LEFT SIDE */}

      <section className="organization-hero">

        <div className="hero-grid"></div>

        <div className="hero-content">

          {/* BRAND */}

          <div className="org-brand">

            <div className="org-brand-icon">
              AC
            </div>

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* MAIN MESSAGE */}

          <div className="hero-message">

            <div className="hero-badge">
              FOR ORGANIZATIONS
            </div>

            <h1>
              Find the
              <span> next generation </span>
              of talent.
            </h1>

            <p>
              Connect your organization with ambitious students
              looking for attachment opportunities and give them
              the experience they need to build their careers.
            </p>


            {/* STATS */}

            <div className="hero-stats">

              <div>
                <strong>01</strong>
                <span>Post opportunities</span>
              </div>

              <div>
                <strong>02</strong>
                <span>Discover students</span>
              </div>

              <div>
                <strong>03</strong>
                <span>Build future talent</span>
              </div>

            </div>

          </div>


          <div className="hero-bottom">
            <span>
              © 2026 Advenware Careere Link
            </span>

            <span>
              Organizations • Students • Careers
            </span>
          </div>

        </div>

      </section>


      {/* RIGHT SIDE */}

      <section className="organization-form-area">

        <div className="organization-form-wrapper">

          {/* MOBILE BRAND */}

          <div className="mobile-org-brand">

            <div className="org-brand-icon">
              AC
            </div>

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HEADER */}

          <div className="org-form-header">

            <div className="form-step">
              ORGANIZATION REGISTRATION
            </div>

            <h1>
              Looking for an attachee?
            </h1>

            <p>
              Create your organization profile and start
              connecting with students looking for attachment
              opportunities.
            </p>

          </div>


          <form onSubmit={handleSubmit}>

            {/* SECTION */}

            <div className="org-section-heading">

              <div className="org-section-number">
                01
              </div>

              <div>
                <h3>Organization details</h3>

                <p>
                  Tell us how we can reach you.
                </p>
              </div>

            </div>


            {/* EMAIL */}

            <div className="org-input-group">

              <label>
                Email address <span>*</span>
              </label>

              <div className="org-input-container">

                <span className="org-input-icon">
                  @
                </span>

                <input
                  type="email"
                  name="email"
                  placeholder="e.g. hr@company.com"
                  value={formData.email}
                  onChange={handleChange}
                />

              </div>

              {errors.email && (
                <small className="org-error">
                  {errors.email}
                </small>
              )}

            </div>


            {/* PHONE */}

            <div className="org-input-group">

              <label>
                Phone number <span>*</span>
              </label>

              <div className="org-input-container">

                <span className="org-input-icon">
                  ☎
                </span>

                <input
                  type="tel"
                  name="phone"
                  placeholder="07XX XXX XXX"
                  value={formData.phone}
                  onChange={handleChange}
                />

              </div>

              {errors.phone && (
                <small className="org-error">
                  {errors.phone}
                </small>
              )}

            </div>


            {/* ORGANIZATION */}

            <div className="org-input-group">

              <label>
                Organization / Company <span>*</span>
              </label>

              <div className="org-input-container">

                <span className="org-input-icon">
                  ▣
                </span>

                <input
                  type="text"
                  name="organization"
                  placeholder="e.g. Advenware Technologies"
                  value={formData.organization}
                  onChange={handleChange}
                />

              </div>

              {errors.organization && (
                <small className="org-error">
                  {errors.organization}
                </small>
              )}

            </div>


            {/* INFORMATION CARD */}

            <div className="organization-info-card">

              <div className="info-icon">
                ✦
              </div>

              <div>

                <strong>
                  Your organization profile
                </strong>

                <p>
                  After registration, you'll be able to
                  provide more details about your attachment
                  opportunities and find students whose skills
                  match your requirements.
                </p>

              </div>

            </div>


            {/* SUBMIT */}

            <div className="org-submit-area">

              <p>
                By continuing, you agree to the
                Advenware Careere Link terms and privacy policy.
              </p>

              <button
                type="submit"
                disabled={loading}
              >

                {loading
                  ? "Creating profile..."
                  : "Create organization profile →"}

              </button>

              <div className="org-login">

                Already registered?

                <button
                  type="button"
                  onClick={() =>
                    console.log("Go to organization login")
                  }
                >
                  Sign in
                </button>

              </div>

            </div>

          </form>

        </div>

      </section>

    </div>
  );
};

export default OrganizationRegistration;